import { render, staticRenderFns } from "./IconAlert.vue?vue&type=template&id=19959ec8&scoped=true&"
import script from "./IconAlert.vue?vue&type=script&lang=js&"
export * from "./IconAlert.vue?vue&type=script&lang=js&"
import style0 from "./IconAlert.vue?vue&type=style&index=0&id=19959ec8&scoped=true&lang=css&"
import style1 from "./IconAlert.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19959ec8",
  null
  
)

component.options.__file = "IconAlert.vue"
export default component.exports